import styled from 'styled-components';

const ListViewContents = styled.div`
  min-width: fit-content;
`;

export default ListViewContents;
